/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState, useEffect } from "react";
export var GtnContext = React.createContext({
    loading: false,
});
export var GtnProvider = function (_a) {
    var children = _a.children, gtnRepository = _a.gtnRepository;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(), profile = _c[0], setProfile = _c[1];
    var requestGtnProfile = function () {
        setLoading(true);
        gtnRepository
            .getProfile()
            .then(function (data) {
            setProfile(data);
        })
            .catch(function () { return null; })
            .finally(function () { return setLoading(false); });
    };
    useEffect(function () {
        requestGtnProfile();
    }, []);
    return (React.createElement(GtnContext.Provider, { value: {
            loading: loading,
            profile: profile,
        } }, children));
};
